import {
  type SearchUsersContentVisibilityQueryVariables,
  ContentType,
  useSearchUsersContentVisibilityQuery,
} from '@exam-management/graphql';
import { useParams } from '@exam-management/router';
import { useMemo } from 'react';

import { mapQBankStructureMemberList } from '../../../utils/users';
import { useUserList } from '../../provider';
import { BaseUserList } from '../base-user-list';
import type { OmittedUserListProps } from '../user-list';

export function QBankStructureMemberList(props: Readonly<OmittedUserListProps>) {
  const {
    moreColumns = [],
    options,
    DataGridProps,
    SelectUsersCountProps = {},
    shouldInvertFilter = false,
  } = props;

  const { searchAndFilterInput, dataGridParams } = useUserList();

  const { sort, pageSize, page, field } = dataGridParams;

  const { search } = searchAndFilterInput;

  const { structureId: contentId = '' } = useParams('/qbank-structures/:structureId/setting');

  const fetchVariables = useMemo<SearchUsersContentVisibilityQueryVariables>(() => {
    return {
      input: {
        order: {
          field: field,
          type: sort,
        },
        paging: {
          pageSize: pageSize,
          currentPage: page,
        },
        contentId: contentId,
        contentType: ContentType.QbankStructure,
        search: search ?? '',
        // TODD: Add status filter when BE is implemented
        isInvertUserFilter: shouldInvertFilter,
        withUserDetails: true,
      },
    };
  }, [searchAndFilterInput, dataGridParams]);

  const {
    data,
    loading: isLoading,
    error,
  } = useSearchUsersContentVisibilityQuery({
    variables: fetchVariables,
    fetchPolicy: 'network-only',
  });

  const users = useMemo(() => {
    if (data?.cvSearchUsersContentVisibility) {
      return mapQBankStructureMemberList(data?.cvSearchUsersContentVisibility.users);
    }
    return [];
  }, [data]);

  const totalCount = data?.cvSearchUsersContentVisibility?.total ?? 0;

  const dataGridProps = {
    ...DataGridProps,
    moreColumns,
    totalCount,
    isLoading,
    rows: users,
    error,
  };

  return (
    <BaseUserList
      options={options}
      dataGridProps={dataGridProps}
      selectUsersCountProps={SelectUsersCountProps}
    />
  );
}
